import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    darkMode: false,
}

const preferenceSlice = createSlice({
    name: 'preference',
    initialState,
    reducers: {
        setDarkMode: (state, action) => {
            state.darkMode = action.payload;
        },
    }
});

export const { setDarkMode } = preferenceSlice.actions;

export default preferenceSlice.reducer;